import bigcartelIconUrl from '@resources/img/account/bigcartel-icon.svg?url'
import bigcommerceIconUrl from '@resources/img/account/bigcommerce-icon.svg?url'
import etsyIconUrl from '@resources/img/account/etsy-icon.svg?url'
import shopifyIconUrl from '@resources/img/account/shopify-icon.svg?url'
import squarespaceIconUrl from '@resources/img/account/squarespace-icon.svg?url'
import woocommerceIconUrl from '@resources/img/account/woocommerce-icon.svg?url'

export const STORE_ICON_URLS: Record<string, string> = {
  bigcartel: bigcartelIconUrl,
  bigcommerce: bigcommerceIconUrl,
  etsy: etsyIconUrl,
  shopify: shopifyIconUrl,
  squarespace: squarespaceIconUrl,
  woocommerce: woocommerceIconUrl
}
